import React from "react";
import {
  TextField,
  Divider,
  Stack,
  Columns,
  Column,
  Text,
} from "@origin-digital/ods-core";
import { Field, FieldInputProps, FieldMetaProps } from "formik";
import { FormValues } from "../types";

interface IHomeUserSiteSupervisorProps {
  type: string;
}

const HomeUserSiteSupervisor = ({ type }: IHomeUserSiteSupervisorProps) => {
  return (
    <Stack space="large">
      <Columns
        collapseBelow="md"
        space={{ xs: "none", md: "xlarge" }}
        alignY="stretch"
      >
        <Column width="2/3">
          <Stack space="large">
            <Text weight="medium">Site supervisor</Text>
            <Stack
              space={{
                xs: "xlarge",
                md: "xxlarge",
              }}
            >
              <Columns
                collapseBelow="sm"
                space={{
                  xs: "xlarge",
                  lg: "large",
                }}
              >
                <Column>
                  <Field name={`${type}.homeUserSiteSupervisor.firstName`}>
                    {({
                      field,
                      meta,
                    }: {
                      field: FieldInputProps<string>;
                      meta: FieldMetaProps<FormValues>;
                    }) => {
                      return (
                        <TextField
                          {...field}
                          id={field.name}
                          variant="outlined"
                          label="First name"
                          hideHelperTextSpace
                          error={!!meta.error}
                          helperText={meta.error}
                        />
                      );
                    }}
                  </Field>
                </Column>
                <Column>
                  <Field name={`${type}.homeUserSiteSupervisor.lastName`}>
                    {({
                      field,
                      meta,
                    }: {
                      field: FieldInputProps<string>;
                      meta: FieldMetaProps<FormValues>;
                    }) => (
                      <TextField
                        {...field}
                        id={field.name}
                        variant="outlined"
                        label="Last name"
                        hideHelperTextSpace
                        error={!!meta.error}
                        helperText={meta.error}
                      />
                    )}
                  </Field>
                </Column>
              </Columns>
              <Field name={`${type}.homeUserSiteSupervisor.phoneNumber`}>
                {({
                  field,
                  meta,
                }: {
                  field: FieldInputProps<string>;
                  meta: FieldMetaProps<FormValues>;
                }) => (
                  <TextField
                    {...field}
                    id={field.name}
                    variant="outlined"
                    label="Phone"
                    hideHelperTextSpace
                    error={!!meta.error}
                    helperText={meta.error}
                  />
                )}
              </Field>
              <Field name={`${type}.homeUserSiteSupervisor.email`}>
                {({
                  field,
                  meta,
                }: {
                  field: FieldInputProps<string>;
                  meta: FieldMetaProps<FormValues>;
                }) => (
                  <TextField
                    {...field}
                    id={field.name}
                    variant="outlined"
                    label="Email"
                    hideHelperTextSpace
                    error={!!meta.error}
                    helperText={meta.error}
                  />
                )}
              </Field>
              <Divider />
            </Stack>
          </Stack>
        </Column>
        <Column width="1/3" />
      </Columns>
    </Stack>
  );
};

export default HomeUserSiteSupervisor;
